module.exports = __webpack_public_path__ + "static/media/img_ranks1.9ef5f2a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/img_ranks1.svg
// module id = 689
// module chunks = 0